import * as tslib_1 from "tslib";
import * as Logger from 'js-logger';
import { Subject } from 'rxjs';
import { takeUntil, timeout } from 'rxjs/operators';
import { ConnectionCloseEvent, ConnectionOpenEvent, DataReceivedEvent, DeckStatus, OvenStatus, } from '@app/connect/oven-data-types';
var logger = Logger.get('elk-bali-client');
var ElkBaliClient = /** @class */ (function () {
    function ElkBaliClient(host) {
        this.host = host;
        this.events = new Subject();
        this.closing = false;
        this.reconnectDelay = ElkBaliClient.RECONNECT_INITIAL_DELAY;
        this.messages = new Subject();
        this.closeEvents = new Subject();
        this.closeEvents.subscribe(this.onClose.bind(this));
    }
    ElkBaliClient.prototype.connect = function () {
        var _this = this;
        if (this.connectionTimeoutTimer !== undefined) {
            console.warn('Already connecting.');
            return;
        }
        this.connectionTimeoutTimer = setTimeout(function () {
            logger.debug("Timeout while connecting to " + _this.host + ". Closing connection.");
            _this.connectionTimeoutTimer = undefined;
            _this.forceClose();
        }, ElkBaliClient.CONNECTION_TIMEOUT);
        this.closing = false;
        this.socket = new WebSocket("ws://" + this.host + ":9080/liveTicker");
        this.socket.onmessage = this.messages.next.bind(this.messages);
        this.socket.onopen = this.onOpen.bind(this);
        this.socket.onclose = this.closeEvents.next.bind(this.closeEvents);
    };
    ElkBaliClient.prototype.disconnect = function () {
        logger.debug('Disconnect called for host: ' + this.host);
        this.closing = true;
        clearTimeout(this.reconnectTimer);
        this.reconnectTimer = undefined;
        if (this.socket !== undefined) {
            this.socket.close();
            this.socket = undefined;
        }
    };
    ElkBaliClient.prototype.onOpen = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                clearTimeout(this.connectionTimeoutTimer);
                this.connectionTimeoutTimer = undefined;
                // Close connection when nothing received within timeout.
                this.messages
                    .pipe(timeout(ElkBaliClient.RECEIVE_TIMEOUT), takeUntil(this.closeEvents))
                    .subscribe(this.onMessage.bind(this), function () {
                    logger.debug("Connection to " + _this.host + " timed out. Closing connection.");
                    _this.forceClose();
                });
                this.events.next(new ConnectionOpenEvent());
                return [2 /*return*/];
            });
        });
    };
    ElkBaliClient.prototype.onMessage = function (e) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var oven, baliStatus, _i, _a, baliDeck;
            return tslib_1.__generator(this, function (_b) {
                oven = new OvenStatus();
                baliStatus = JSON.parse(e.data);
                for (_i = 0, _a = baliStatus.Herde; _i < _a.length; _i++) {
                    baliDeck = _a[_i];
                    oven.decks.push(new DeckStatus(baliDeck.Backzeit, baliDeck.BackprogrammNummer));
                }
                this.events.next(new DataReceivedEvent(oven));
                return [2 /*return*/];
            });
        });
    };
    ElkBaliClient.prototype.onClose = function () {
        this.socket = undefined;
        clearTimeout(this.connectionTimeoutTimer);
        this.connectionTimeoutTimer = undefined;
        this.events.next(new ConnectionCloseEvent());
        if (!this.closing) {
            this.reconnect();
        }
    };
    ElkBaliClient.prototype.forceClose = function () {
        if (this.socket !== undefined) {
            logger.debug('Forcing WebSocket close for host: ' + this.host);
            this.socket.onmessage = function () { return undefined; };
            this.socket.onopen = function () { return undefined; };
            this.socket.onclose = function () { return undefined; };
            this.socket.close();
        }
        this.closeEvents.next();
    };
    ElkBaliClient.prototype.reconnect = function () {
        var _this = this;
        if (this.reconnectTimer !== undefined) {
            logger.warn('Reconnect triggered while already reconnecting.');
            return;
        }
        this.reconnectTimer = setTimeout(function () {
            _this.reconnectTimer = undefined;
            _this.reconnectDelay = Math.min(ElkBaliClient.RECONNECT_MAX_DELAY, _this.reconnectDelay * 2);
            _this.connect();
        }, this.reconnectDelay);
    };
    ElkBaliClient.RECONNECT_MAX_DELAY = 60 * 1000;
    ElkBaliClient.RECONNECT_INITIAL_DELAY = 5 * 1000;
    ElkBaliClient.CONNECTION_TIMEOUT = 15 * 1000;
    ElkBaliClient.RECEIVE_TIMEOUT = 20 * 1000;
    return ElkBaliClient;
}());
export { ElkBaliClient };
